module.exports = __webpack_public_path__ + "static/media/edit.e62249ce.svg";